import { render } from "./JobCourt.vue?vue&type=template&id=1928e9b9&scoped=true"
import script from "./JobCourt.vue?vue&type=script&lang=js"
export * from "./JobCourt.vue?vue&type=script&lang=js"

import "./JobCourt.vue?vue&type=style&index=0&id=1928e9b9&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1928e9b9"]])

export default __exports__